import { render, staticRenderFns } from "./BlockNotification.vue?vue&type=template&id=58022330&scoped=true&"
import script from "./BlockNotification.vue?vue&type=script&lang=js&"
export * from "./BlockNotification.vue?vue&type=script&lang=js&"
import style0 from "./BlockNotification.vue?vue&type=style&index=0&id=58022330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58022330",
  null
  
)

export default component.exports